







import Vue, { PropType } from "vue";
import { GroupQuery_group, GroupQuery_group_sessions } from "@/graphql/generatedTypes/GroupQuery";
import formatUtils from "@/components/FormatUtil";
import GroupSessionTime from "@/components/GroupSessionTime.vue";

export default Vue.extend({
  name: "GroupDateTime",
  components: { GroupSessionTime },
  props: {
    group: Object as PropType<GroupQuery_group>
  },
  computed: {
    firstSession(): GroupQuery_group_sessions {
      if (this.group.sessions[0]?.status === "canceled") {
        return this.group.sessions[1];
      }
      return this.group.sessions[0];
    }
  },
  methods: {
    formattedStartDate(): string {
      const startDate = this.firstSession?.date || "";
      return formatUtils.prettyDateShort(startDate);
    },
    formattedEndDate(): string {
      const endDate = this.group.sessions[this.group.sessions.length - 1]?.date || "";
      return formatUtils.prettyDateShort(endDate);
    }
  }
});
